import './App.css'
import { Router } from './components/Router'
import { ErrorBoundary } from './components/common/ErrorBoundary'
import { ToastProvider } from './components/ui/EnhancedToast'
import { AuthProvider } from '@/features/auth'
import { ConnectionProvider } from '@/shared/context/ConnectionContext'

function App() {
  return (
    <ErrorBoundary>
      <ConnectionProvider>
        <AuthProvider>
          <ToastProvider>
            <Router />
          </ToastProvider>
        </AuthProvider>
      </ConnectionProvider>
    </ErrorBoundary>
  )
}

export default App